import type { StepperPassThroughOptions } from "primevue/stepper";

export const stepper: StepperPassThroughOptions = {
  root: "has-[[data-pc-name=stepitem]]:flex has-[[data-pc-name=stepitem]]:flex-col",
  separator:
    "flex-1 w-full h-[2px] bg-surface-200 dark:bg-surface-700 transition-shadow duration-200"
  // Note: transition PassThrough option removed in PrimeVue 4.x
};
